class ProgressivePagingController {
    constructor($scope, $element, pagingService, filterService) {
        this.$onInit = function() {
            this.pagingService = pagingService;
            this.progress = 0;
            this.viewedCount = 0;
            this.totalCount = 0;
            this.unavailableCount = 0;
            this.id = Date.now();

            $scope.isHidingOOS = filterService.getHideOutOfStockPreference();
            this.pageName = $scope.ctrl.pageName;
            $scope.ctrl.caption = $scope.ctrl.caption || 'product';
            $scope.filterService = filterService;

            $scope.$on('filter:toggleOOS', function() {
                $scope.isHidingOOS = $scope.filterService.getHideOutOfStockPreference();
            });

            this.unsubscribeService = function () {
                this.pagingService.clearListener(this.id);
            };

            this.loadMore = function () {
                if ($scope.ctrl.onLoadMore != null) {
                    $scope.ctrl.onLoadMore();
                }
            };

            function onProgressChanged(args) {
                this.viewedCount = args.loadedCount;
                this.totalCount = args.totalCount;
                this.progress = (this.viewedCount / (this.totalCount * 1.0)) * 100;

                if (this.progress > 0) {
                    setTimeout(() => {
                        const pattern = /(\d+\.?\d*)\%/gi;
                        const bar = $element.find('.progressive-paging--progress-bar');
                        const style = bar.css('background-image')
                            .replace(pattern, this.progress + '%');

                        bar.css('background-image', style);
                    });
                }
            }

            this.pagingService.addListener(this.id, onProgressChanged.bind(this));

            $scope.$on('$destroy', () => this.unsubscribeService());
            $scope.$on('filter:toggleOOS', function() {
                $scope.ctrl.isHidingOOS = $scope.filterService.getHideOutOfStockPreference();
            });
        };
    }
}

module.exports = function () {
    return {
        restrict: 'E',
        controllerAs: 'ctrl',
        controller: ['$scope', '$element', 'ProgressivePagingService', 'FiltersService', ProgressivePagingController],
        scope: {
            onLoadMore: '&', // should be a promise
            pageName: '=?',
            caption: '@'
        },
        bindToController: true,
        template: require('./progressive-paging-tempate.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/paging/progressive-paging-directive.js
 **/